<template>
  <v-flex>
    <v-card-title class="card-title">
      Personal Info
      <span @click="showModal=true">UPDATE INFO</span>
    </v-card-title>
    <v-card-text v-if="profile" class="personal-info">
      <span>{{ profile.name }}</span>
      <span>{{ profile.phone }}</span>
      <span>{{ profile.city }}<span v-if="profile.city && profile.state">,</span> {{ profile.state }} </span>
      <span />
      <span v-if="profileStatus==='agent' && profile.mls">License#: {{ profile.mls }}</span>
      <span v-if="profile.primaryMlsScope">MLS Scope: {{ profile.primaryMlsScope }}</span>
    </v-card-text>
    <default-modal
      :show-modal="showModal"
      :max-width="'504px'"
      :width="'100%'"
      :modal-title="'Update Personal Information'"
      @close-modal="showModal=false"
    >
      <v-flex v-if="profile" class="agent-data-container">
        <span>NAME</span>
        <input v-model="profileForm.name" type="text" :placeholder="profileForm.name">
        <span>PHONE</span>
        <input v-model="profileForm.phone" type="text" :placeholder="profileForm.phone">
        <span>CITY</span>
        <input v-model="profileForm.city" type="text" :placeholder="profileForm.city">
        <span>STATE</span>
        <input v-model="profileForm.state" type="text" :placeholder="profileForm.state">
        <span v-if="profileStatus==='agent'">LICENSE#</span>
        <input v-if="profileStatus==='agent'" v-model="profileForm.mls" type="text" :placeholder="profileForm.mls">
        <span v-if="profile.mlsScopes && profile.mlsScopes.length > 1">MLS SCOPE</span>
        <!-- TODO: the below default selected value doesn't work -->
        <select v-if="profile.mlsScopes && profile.mlsScopes.length > 1" v-model="profileForm.primaryMlsScope">
          <option v-for="scope in profile.mlsScopes" :key="scope" :selected="scope == profile.primaryMlsScope" :value="scope">
            {{ scope }}
          </option>
        </select>
      </v-flex>
      <v-btn
        :color="colors.hwayzBrandBlue"
        class="save-changes-button"
        @click="updateInfo"
      >
        Save Changes
      </v-btn>
      <v-btn
        :color="colors.hwayzWhite"
        class="cancel-button"
        @click="showModal=false"
      >
        Cancel
      </v-btn>
    </default-modal>
  </v-flex>
</template>
<script>
import DefaultModal from '../../components/modals/DefaultModal'
import { updateMyProfile } from '../../services/profile'
import { mapMutations, mapGetters, mapState } from 'vuex'
import colors from '../../scss/_colors.scss'
export default {
  components: {
    DefaultModal
  },
  props: {
    profile: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      showModal: false,
      profileForm: {
        name: '',
        phone: '',
        city: '',
        state: '',
        mls: ''
      },
      colors
    }
  },
  computed: {
    ...mapGetters('agent', ['getAgentLogo', 'getClients']),
    ...mapState('common', [
      'profileStatus'
    ])
  },
  watch: {
    profile() {
      this.getData()
    }
  },
  created() {
    this.getData()
  },
  methods: {
    ...mapMutations('agent', {
      setAgentData: 'SET_AGENT_DATA'
    }),
    ...mapMutations('client', {
      setClientData: 'SET_CLIENT_DATA'
    }),
    async updateInfo() {
      const updatedPersonalInfo = await updateMyProfile(this.profileForm)
      if (this.profileStatus === 'agent') {
        updatedPersonalInfo.data.clients = this.getClients
        this.setAgentData(updatedPersonalInfo.data)
      } else {
        this.setClientData(updatedPersonalInfo.data)
      }
      this.showModal = false
    },
    getData() {
      for (let key in this.profileForm) {
        if (this.profile && this.profile[key]) {
          this.profileForm[key] = this.profile[key]
        }
      }
    }
  }
}

</script>
<style lang="sass">
#modalContainerCard
  padding: 1rem 2rem 2rem
.agent-data-container
  display: flex
  justify-content: flex-start
  flex-direction: column
  input[type=text]
    border: 1px solid $color-grey
    height: 40px
    margin: 1rem 0 2rem
    padding-left: 15px
  select
    position: relative;
    background: transparent;
    background-image: none;
    display: block;
    width: 100%;
    outline: none;
    cursor: pointer;
    z-index: 2;
    border: 1px solid $color-grey
    height: 40px
    margin: 1rem 0 2rem
    padding: 10px 10px 10px 5px;
    text-overflow: '';
    text-indent: 5px;
.agent-data-container input
  display: block
  text-align: left
.agent-data-inputs-wrapper
  display: flex
  flex-direction: column
  @media only screen and (max-width: 768px)
    width: 100%
.agent-data-inputs-wrapper span, .agent-data-container span
  display: block
  text-align: left
  font-weight: 450
  font-size: 1.2rem
// .agent-inputs-container
//   display: flex
//   justify-content: space-between
//   flex-direction: row
//   @media only screen and (max-width: 768px)
//     flex-wrap: wrap
  // input[type=text]
  //   border: 1px solid $color-grey
  //   height: 40px
  //   width:  100%
  //   margin: 1rem 0 2rem
  //   padding-left: 15px
.save-changes-button, .cancel-button
  width: 100%
  margin: 0.5rem auto !important
  border-radius: 4px !important
  height: 40px
.save-changes-button
  color: $hwayzWhite !important
.cancel-button
  border: 0.1rem solid $hwayzMediumGray !important
.save-changes-button .v-btn__content, .cancel-button .v-btn__content
  font-weight: 500 !important
.save-changes-button:hover, .cancel-button:hover
  background-color: $hwayzBrandGold !important
.cancel-button:hover
  color: $hwayzWhite !important
  border: none !important
.personal-info
  display: flex
  justify-content: flex-start !important
  flex-direction: column
  text-align: left
  padding: 16px 16px !important
.personal-info span:not(:first-child)
  padding-top: 6px
</style>
